package de.oevbs.kunde.kundenportal2.services.account.password

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.account.ChangePassword
import de.oevbs.kunde.kundenportal2.model.services.account.currentPassword
import de.oevbs.kunde.kundenportal2.model.services.account.newPassword
import de.oevbs.kunde.kundenportal2.model.services.account.newPasswordRepeat
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.services.account.password.model.PasswordStore
import dev.fritz2.core.RenderContext
import kotlinx.coroutines.flow.mapNotNull

fun RenderContext.updatePasswordPage(page: Page) {
    val passwordStore = PasswordStore(job)
    headerImageLayout {
        title(page.linkTitle)
        content {
            contentContainer {
                passwordStore.progress.render { step ->
                    when (step) {
                        GeneralProgressStep.SUBMIT1 -> updatePasswordForm(passwordStore)
                        GeneralProgressStep.SUCCESS2 -> messagePagePre(
                            header = "Passwort erfolgreich geändert.",
                            preContent = PortalContactNotes.AccountPasswordChanged().note
                        )
                    }
                }
            }
        }
    }
}

private fun RenderContext.updatePasswordForm(passwordStore: PasswordStore) {
    paragraph {
        +"Hier können Sie das Passwort für Ihren Account ändern."
    }
    inputPassword {
        label("Aktuelles Passwort eingeben")
        value(passwordStore.map(ChangePassword.currentPassword()))
    }
    inputPassword {
        label("Neues Passwort eingeben")
        value(passwordStore.map(ChangePassword.newPassword()))
        iconClickableWithPopover(MaterialIconsOutlined.help, HelpPopovers.password)
    }
    inputPassword {
        label("Neues Passwort wiederholen")
        value(passwordStore.map(ChangePassword.newPasswordRepeat()))
    }
    buttonContainer {
        btn {
            label("Neues Passwort speichern")
            busy(globalSubmitTracker.data)
        }.clicks.mapNotNull { PortalSession.current?.username } handledBy passwordStore.submitChangePassRequest
    }
}